import { classNames } from "primereact/utils";

import styles from "../empty-state.module.scss";
import { useEmptyStateContext } from "../empty-state.context";
import type { EmptyStateTitleProps } from "../types-empty-state";

export function EmptyStateTitle({ children, className, ...rest }: EmptyStateTitleProps) {
  const { partTestId, classNames: parts } = useEmptyStateContext();

  return (
    <p
      className={classNames(styles.title, parts.title, className)}
      data-testid={partTestId("title")}
      {...rest}
    >
      {children}
    </p>
  );
}
EmptyStateTitle.displayName = "EmptyState.Title";
